/* ====================== Pagination ====================== */
import { useTranslation } from "react-i18next";

export default function Pagination({
  page,
  limit = 20,
  totalCount = 0,
  onPrev,
  onNext,
  onPage,
}) {
  const { t } = useTranslation();
  const currentPage = Number(page) || 1;
  const totalPages = Math.max(1, Math.ceil(totalCount / limit));

  const canPrev = currentPage > 1;
  const canNext = currentPage < totalPages;

  // 페이지 버튼 배열 (예: [1, 2, 3, 4, 5])
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <div className="paginationBox">
      <button disabled={!canPrev} onClick={onPrev}>
        {`◀ ${t("common.pagination.prev")}`}
      </button>

      {pages.map((p) => (
        <button
          key={p}
          onClick={() => onPage?.(p)}
          className={p === currentPage ? "active" : ""}
        >
          {p}
        </button>
      ))}

      <button disabled={!canNext} onClick={onNext}>
        {`${t("common.pagination.next")} ▶`}
      </button>
    </div>
  );
}
